import { InvoiceStatusEnum } from 'domains-billing-types';
import { INVOICEID_NO_INVOICE, Charge} from 'lane-shared/domains/billingPayments/types';

export function showServiceRequestChargeStatus(
    isWOInvoicingOptionsFFEnabled: boolean,
    isBPInvoicingDisabled: boolean,
    isSRInvoiceOptionsEnabled: boolean | undefined,
    charge: Charge,
): boolean {
    if (!isWOInvoicingOptionsFFEnabled) {
        if (charge.status === 'VOIDED') return true;

        if (charge.invoice?.status === InvoiceStatusEnum.EXTERNALLY_MANAGED) return false;

        return true;
    }

    if (charge.status === 'VOIDED') return true;

    if (charge.invoice?.status === InvoiceStatusEnum.EXTERNALLY_MANAGED) return false;

    if (isBPInvoicingDisabled) return false;

    if (isSRInvoiceOptionsEnabled !== undefined && !isSRInvoiceOptionsEnabled) return false;

    return charge.invoiceId !== INVOICEID_NO_INVOICE;
}